/**
 * The Step 3 locale switch options (TO-124 REQ-009): the tenant's enabled locales in
 * their configured order, with the offer's locale prepended when it is not among
 * them — so the current locale is always selectable, and is the only option when
 * the tenant lists none.
 */
export const localeOptions = (enabled: readonly string[], current: string): string[] =>
	enabled.includes(current) ? [...enabled] : [current, ...enabled]
